import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const ChevronUpIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M16.5901 16L12.0001 11.0553L7.41006 16L6.00006 14.4777L12.0001 8L18.0001 14.4777L16.5901 16Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
})
ChevronUpIcon.displayName = 'ChevronUpIcon'
export default ChevronUpIcon
